/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_CreateInputs */

const vi_product_create = /** @type {(inputs: Product_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo sản phẩm`)
};

/**

* @param {Product_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_create = /** @type {((inputs?: Product_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_create(inputs)
});